import MyProfileButton from './MyProfileButton.gql';

export default MyProfileButton;
